import React, { Suspense, lazy } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ROUTES } from '../utils/utils';
import Layout from '../components/layout/Layout';

// -------------------------------------
// Lazy Imports
// -------------------------------------

const HomePage = lazy(() => import('./home/HomePage'));
const ProjectsPage = lazy(() => import('./projects/ProjectsPage'));
const ProjectDetailPage = lazy(() => import('./projects/ProjectDetailPage'));
const Founders = lazy(() => import('./founders/Founders'));

// -------------------------------------
// Component
// -------------------------------------

function Main() {
	return (
		<HashRouter>
			<Suspense fallback={<div>Loading</div>}>
				<Routes>
					<Route element={<Layout />}>
						<Route path={ROUTES.home} element={<HomePage />} />
						<Route path={ROUTES.projects} element={<ProjectsPage />} />
						<Route
							path={ROUTES.projectDetail}
							element={<ProjectDetailPage />}
						/>
						<Route
							path={`/${ROUTES.founders}/*`}
							element={<Founders />}
						/>
						<Route path="*" element={<div>Not found</div>} />
					</Route>
				</Routes>
			</Suspense>
		</HashRouter>
	);
}

export default Main;
